import {
  chatAppService as service,
  ChatEvent,
  ChatApplicationServiceErrorName
} from 'langyan';
import eventBus from '@/event-bus';

const subscribe = (event, handler) => {
  service.subscribeEventHandler(event, domainEvent => {
    log.tag('event', event).info(domainEvent);
    handler(domainEvent);
  });
};

export function subscribeChatEvents(commit, state, rootState, dispatch) {
  subscribe(ChatEvent.ParticipantSpoke, domainEvent => {
    let chatId = domainEvent.entityId;
    let tempId = domainEvent.body.Item2;
    let messages = domainEvent.body.Item3; // chatMessageDto array
    let totalCount = domainEvent.body.Item4; // total message count of chat
    commit('updateChatMessages', {chatId, tempId, messages, totalCount});

    if (state.currentChat.id === chatId) {
      eventBus.$emit('receive-current-chat-message');
    }
  });

  subscribe(ChatEvent.ParticipantReadToMessageCount, domainEvent => {
    let chatId = domainEvent.body.Item1;
    let username = domainEvent.body.Item2;
    let readCount = domainEvent.body.Item3;
    commit('updateChatReadCount', {chatId, username, readCount});
  });

  subscribe(ChatEvent.EalierChatMessagesArrived, domainEvent => {
    let chatId = domainEvent.entityId;
    let messages = domainEvent.body; // chatMessageDto array
    commit('updateChatMessages', {chatId, messages});
  });

  subscribe(ChatEvent.NewChatIsCreated, domainEvent => {
    let chatDto = domainEvent.body;
    let participantUsernames = Array.from(chatDto.participants.values());

    dispatch('user/fetchUserByUsernameAsync', participantUsernames, {root: true});
    commit('updateChat', chatDto);
  });

  // subscribe error event handler
  service.errorOccurred.addListener(ChatApplicationServiceErrorName, error => {
    log.tag('event', ChatApplicationServiceErrorName).error(error);
    dispatch('alert/addError', error.message, {root: true});
  });
}
